export default "__VITE_ASSET__D$2aq8Zl__"